/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { ButtonEl, ButtonJsxProps } from 'common/components/button';

// this is in a separate file for Panel jsx

export function renderCardTitleActions(className: string, positiveProps: ButtonJsxProps, negativeProps: ButtonJsxProps) {
  return <div attrs={{
    class: className
  }} data-sentry-component="renderCardTitleActions" data-sentry-source-file="card-title.tsx">
      <ButtonEl {...positiveProps} data-sentry-element="ButtonEl" data-sentry-source-file="card-title.tsx" />
      <ButtonEl {...negativeProps} data-sentry-element="ButtonEl" data-sentry-source-file="card-title.tsx" />
    </div>;
}